/* eslint-disable react/no-multi-comp */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import { isEmpty } from 'lodash';
import { defaultDeleteFilter, showSequenceNumber } from 'utils/constants';
import { Button } from 'reactstrap';
import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
import ErrorMessage from 'components/ErrorMessage';
import Loader from 'components/common/Loader';
import moment from 'moment';
import {
  LATEST_ALL_BIDS_QUERY,
  LATEST_ALL_BIDS_SUBSCRIPTION_QUERY,
} from 'utils/CommonGraphQL';
import {
  vendorBidsColumns,
  vendorChildBidsColumns,
} from 'components/Drawers/components/VendorDetailsDrawer/constant';

const ChildBids = ({ row }) => {
  const { allBids } = row.original;
  return (
    <FSBTable
      keyField="id"
      columns={vendorChildBidsColumns}
      data={allBids || []}
      totalCount={allBids?.length}
      pagePerSize={allBids?.length}
      // SubComponent={LastRow}// May use later
      search={false}
      pagination={false}
      isRowExpanded
      getRowCanExpand={() => true}
      showPagination={false}
    />
  );
};

const VendorBidOfferAndDemandTable = ({ filter = [] }) => {
  const todayDate = new Date();
  const date = moment(todayDate);
  const yesterdayDate = date.subtract(2, 'days').toDate();
  const yesterDateAndTimeMilliseconds = yesterdayDate.valueOf();

  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'parentBid',
        value: '',
        type: 'NULL',
        op: 'IS_NULL',
      },
      {
        key: 'createdAt',
        value: yesterDateAndTimeMilliseconds,
        type: 'DATE',
        op: 'GTE',
      },
      ...filter,
      { ...defaultDeleteFilter },
    ],
    sortCol: 'latestBid.id',
    sortDirection: 'desc',
    pageNo: 1,
    pageSize: 10,
  });

  const { data, loading, error, subscribeToMore } = useQuery(
    LATEST_ALL_BIDS_QUERY,
    {
      variables: { ...filters },
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  );

  const findIndexOfItem = (item) => {
    return vendorBidsColumns.findIndex((itm) => itm.accessorKey === item);
  };
  vendorBidsColumns[findIndexOfItem('SNo')].cell = ({ cell, row }) => {
    return (
      <>
        {row.getCanExpand() ? (
          <Button
            color="link"
            className="text-decoration-none p-0 text-active"
            type="button"
            {...{
              onClick: row.getToggleExpandedHandler(),
              style: { cursor: 'pointer' },
            }}
          >
            {row.getIsExpanded() ? (
              <MdOutlineExpandLess className="me-2" size={20} />
            ) : (
              <MdOutlineExpandMore className="me-2" size={20} />
            )}
          </Button>
        ) : null}
        {showSequenceNumber(cell, filters)}
      </>
    );
  };

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: LATEST_ALL_BIDS_SUBSCRIPTION_QUERY,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;

        return subscriptionData.data;
      },
    });

    return () => unsubscribe();
  }, []);

  const lastErrorRef = useRef('');
  useEffect(() => {
    if (error?.message && error.message !== lastErrorRef.current) {
      lastErrorRef.current = error.message;
    }
  }, [error]);

  // method for use of subscribeToMore
  if (loading && !data?.allBids?.groupedBids) {
    return <Loader />;
  }
  if (error && !data?.allBids?.groupedBids)
    return <ErrorMessage error={error} />;
  if (!data?.allBids?.groupedBids) return 'Bids not found';

  const { totalCount, totalPages } = data?.allBids || {};
  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };

  return (
    <div className="expandable-table">
      {/* Common data table to show users list*/}
      <FSBTable
        data={data?.allBids?.groupedBids || []}
        columns={vendorBidsColumns}
        currentPageNo={filters.pageNo}
        pageSize={filters.pageSize}
        totalPages={totalPages || 0}
        totalCount={totalCount || 0}
        keyField="id"
        search={false}
        pagination={false}
        remote
        loading={loading}
        striped={false}
        hover={false}
        bordered={false}
        wrapperClass="table-responsive word-break"
        handlePageChange={handlePageChange}
        SubComponent={ChildBids}
        // defaultSorting={defaultSorting}

        isRowExpanded={false}
        getRowCanExpand={() => true}
      />
    </div>
  );
};

export default VendorBidOfferAndDemandTable;
